import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

import { breakpoints } from "./breakpoints";
import { components } from "./components";
import { styles } from "./global-styles";
import { textStyles } from "./text-styles";

import { semanticColors } from "./semantic-tokens/colors";

import { colors } from "./tokens/colors";
import { radii } from "./tokens/radius";
import { sizes } from "./tokens/sizes";
import { spacing } from "./tokens/spacing";
import { transition } from "./tokens/transition";
import {
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
} from "./tokens/typography";

export const DEFAULT_THEME_PREFERENCE = "system";

const config: ThemeConfig = {
  initialColorMode: DEFAULT_THEME_PREFERENCE,
  useSystemColorMode: false,
};

const tokens = {
  colors,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  radii,
  sizes,
  // Chakra v2 reads the spacing scale from the `space` key.
  space: spacing,
  transition,
};

const semanticTokens = {
  colors: semanticColors,
};

export const timescaleTheme = {
  config,
  breakpoints,

  ...tokens,
  semanticTokens,

  styles,
  textStyles,
};

export const chakraTheme = extendTheme(timescaleTheme, {
  components,
});

/**
 * Alias required by `chakra-cli tokens` (see `yarn generate:theme-typings`),
 * which resolves the theme as `mod.default || mod.theme`. Application code
 * should import `chakraTheme` instead.
 */
export const theme = chakraTheme;
